/**
 * The flag that scopes a browser TAB to previewing one app's catalog.
 *
 * sessionStorage, not localStorage (which GroupContext.js already owns for a
 * different, unrelated key — deliberately not reused, so these two concerns
 * can never collide). The restriction belongs to the tab the developer-portal
 * handoff opened, not to the account: a fresh tab, logged in normally, is a
 * person using their own account and was never the thing to restrict.
 *
 * Set once on arrival (GraphView.js, when catalogAppId is present). Two ways
 * out: closing the tab (sessionStorage dies with it), or signing out — the
 * flag is a property of the SESSION the handoff logged you into, not of the
 * tab forever, so AuthContext's clearLocalAuth() clears it on every sign-out.
 * Without that second path, a preview tab that signs out and back in stays
 * bounced to /app/:id/graph with no affordance explaining why.
 */
const KEY = 'paradigm:appPreview';

export function setAppPreview(id, name) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ id, name }));
  } catch { /* private mode / quota — preview just won't persist across a reload */ }
}

export function getAppPreview() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAppPreview() {
  try {
    sessionStorage.removeItem(KEY);
  } catch { /* no-op */ }
}
